<template>
    <el-drawer
        :title="`${item.id ? '编辑':'新增'}素材`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form" label-position="top">
                <el-form-item label="上传" v-check="{'必传': !form.url}">
                    <el-upload
                        class="photo_uploader fx-col"
                        action=""
                        :accept="type == 4 ? 'audio/wav' : 'image/png,image/svg+xml'"
                        :show-file-list="false"
                        :before-upload="uploadPic">
                        <template v-if="form.url != null">
                            <img v-if="type !=4" :src="form.url" class="img" ref="img" @load="analysePic()">
                            <i v-else class="el-icon-message-solid uploader-icon"></i>
                        </template>

                        <i v-else class="el-icon-plus uploader-icon"></i>

                        <div v-if="type==4" slot="tip" class="el-upload__tip">只能上传wav格式文件。</div>
                        <div v-if="type!=4" slot="tip" class="el-upload__tip">只能上传png或者svg格式文件。</div>
                    </el-upload>

                </el-form-item>
                <el-form-item label="素材名称" v-check="{'必填': !form.name}">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="选择分类" v-check="{'必选': !form.categoryIdArray}">
                    <el-checkbox-group v-model="form.categoryIdArray">
                        <el-checkbox v-for="item in categories" :key="item.id" :label="item.id">
                            {{item.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <!-- <el-form-item label="选择业务分类">
                    <el-checkbox-group v-model="form.businessTypeArray">
                        <el-checkbox v-for="item in businessType" :key="item.id" :label="item.id">
                            {{item.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item> -->
                <el-form-item label="标签">
<!--                    <el-input v-model="form.tags" placeholder="多个标签用 ，隔开"></el-input>-->

                    <el-select
                        style="width: 100%"
                        v-model="form.tags"
                        multiple
                        filterable
                        allow-create
                        default-first-option
                        placeholder="请选择标签">
                        <el-option
                            v-for="item in tags"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="">
                    版权保护  <el-checkbox v-model="form.copyright"></el-checkbox>
                </el-form-item> -->
            </el-form>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>
.img {
    max-width: 200px;
    max-height: 200px;
}
</style>


<script>


    export default {
        props: [
            "item",
            "type",
        ],
        data() {
            return {
                show: true,
                form: {categoryIdArray:[]},

                categories: [],
                businessType:[],
                tags:[],
            }

        },
        watch: {
            item:  {
                immediate: true,
                handler: function (newValue) {
                    this.form = {...this.item,
                        tags: this.item.tagArray ? this.item.tagArray : [],
                        categoryIdArray: this.item.categoryIdArray ? this.item.categoryIdArray : [],
                        //businessTypeArray: this.item.businessTypeArray ? this.item.businessTypeArray :[],
                        type: this.type
                    }
                }
            }
        },


        methods: {
            close() {
                this.$emit("close");
            },
            sub() {

                this.$checkForm(this.$refs.form).then(success => {
                    if (success) {
                        //校验通过，干什么....
                        this.$ajaxPost("/material/save", {
                            material: {...this.form,state:3, tags: this.form.tags.join(","), categories: this.form.categoryIdArray.join(',')}
                        }, data => {
                            this.$showSuccess("保存成功", 1200, () => {
                                this.$emit("submit");
                            })
                        })
                        return false;
                    } else {
                        this.$showError("请输入内容再保存");
                    }
                })
            },
            uploadPic(file) {
                var fileSize = (file.size / 1024).toFixed(2);
                window.calFileMd5(file, (file,  md5) => {
                    let newFile = new File([file], md5 + file.name.substr(file.name.lastIndexOf(".")), {type: file.type});
                    this.$uploadQiniu(newFile, "material/", {
                        randomDirectory: false,
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {url: file.url,fileSize:fileSize});
                        },
                    })
                })
                return false;
            },
            loadCategories() {
                //分类上，造型和角色用一个分类
                this.$ajaxGet(`/materialCategory/list/${this.type == 2 ? 1:this.type}-true`, data => {
                    this.categories = data.result;
                })
            },
            loadBusinessType() {
                this.$ajaxGet(`/materialCategory/list/7-true`, data => {
                    this.businessType = data.result;
                })
            },
            analysePic() {
                let img = this.$refs.img;
                this.form.info = JSON.stringify([
                    //造型取中心点，背景取全尺寸
                    parseInt(this.type == 2 ? img.naturalWidth/2 : img.naturalWidth),
                    parseInt(this.type == 2 ? img.naturalHeight/2 : img.naturalHeight),
                    img.getAttribute("src").endsWith("svg") ? 1 : 2
                ])
            },
            /**
             * 加载标签
             */
            loadTags() {
                this.$ajaxGet("/material/listTags", data => {
                    this.tags = data.result ? data.result.map(item => item.name) : [];
                })
            }
        },
        mounted() {
        },
        created() {
            this.loadCategories();
            this.loadTags();
            this.loadBusinessType();
        }
    }
</script>
